import { TLEventList } from '../ab/event';
import { c_event_tags } from '../mdl/c-event-tag';
import { FPageCarouselsBlock } from '../mdl/f-page-block';
import { legacyEventsGetActiveByTagId } from '../mdl/zzz-legacy-open-events';
import { the_user } from '../me/login';
import { getCountry } from '../me/me';
import { UIButton } from '../ui/component/button';
import { $el } from '../ui/elements';
import { xavis_experiments } from '../y/debug';
import { $i18n, yGetI18N } from '../y/i18n';
import { $location } from '../y/location';
import { $id } from '../y/types';
import { blkRegister } from './registry';

blkRegister('carousels', (_b: FPageCarouselsBlock, _: HTMLElement, promises: Promise<any>[], id: string) => {
    if(xavis_experiments) {
        const carousel_block = $el.DIV('tl-events-block');
        const carousel_tags = c_event_tags.all.filter(t => t.carousel?.includes(getCountry()) && t.carousel_image);
        if(carousel_tags.length) {
            promises.push(Promise.all(carousel_tags.map(t => legacyEventsGetActiveByTagId(t.id).then(e => [t, e] as const))).then(carousels => {
                for(let [tag, events] of carousels) {
                    if(!tag.flags.show_all_cities && the_user)
                        events = events.filter(e => e.model.city == $id.idToObjectId(the_user!.city_id));
                    events = TLEventList.filterEvents(events, tag.flags.show_future ? 'future' : 'active');
                    if(!events.length) continue;
                    const tag_slug = tag.slug;
                    carousel_block.ui_add($el.DIV('tl-events-block', [
                        $el.DIV('l-h r-header w-block', [
                            $el.DIV('r-text p-f-events-title', yGetI18N(tag.name)),
                            tag_slug && new UIButton({
                                title: $i18n.tl.b_see_all, classes: 'ui-tint-reverse', on_click: () => {
                                    $location.navigate(['genre', tag_slug]);
                                }
                            })
                        ]),
                        new TLEventList('carousel', 'carousel', 'event', events, { tag, classes: 'w-block', id: `${id}-${tag.id}` }),
                    ]));
                }
            }));
        }

        return carousel_block;
    } else {
        const carousel_block = $el.DIV('tl-events-block');
        const carousel_tags = c_event_tags.all.filter(t => t.carousel?.includes(getCountry()) && t.carousel_image);
        if(carousel_tags.length) {
            promises.push(Promise.all(carousel_tags.map(t => legacyEventsGetActiveByTagId(t.id).then(e => [t, e] as const))).then(carousels => {
                for(let [tag, events] of carousels) {
                    if(!tag.flags.show_all_cities && the_user)
                        events = events.filter(e => e.model.city == $id.idToObjectId(the_user!.city_id));
                    events = TLEventList.filterEvents(events, tag.flags.show_future ? 'future' : 'active');
                    if(!events.length) continue;
                    const tag_slug = tag.slug;
                    carousel_block.ui_add($el.DIV('tl-events-block', [
                        $el.DIV('l-h r-header w-block', [
                            $el.DIV('r-text p-f-events-title', yGetI18N(tag.name)),
                            tag_slug && new UIButton({
                                title: $i18n.tl.b_see_all, classes: 'ui-tint-reverse', on_click: () => {
                                    $location.navigate(['genre', tag_slug]);
                                }
                            })
                        ]),
                        new TLEventList('carousel', 'carousel', 'event', events, { tag, classes: 'w-block', id: `${id}-${tag.id}` }),
                    ]));
                }
            }));
        }

        return carousel_block;
    }
});
